var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 16.6663H16.6747M3.33301 16.6663H3.34134M6.66634 16.6663H6.67467M9.99967 16.6663H10.008M13.333 16.6663H13.3413M16.6663 3.33301H16.6747M3.33301 3.33301H3.34134M6.66634 3.33301H6.67467M9.99967 3.33301H10.008M13.333 3.33301V3.34134M3.33301 7.49967C3.33301 7.27866 3.42081 7.0667 3.57709 6.91042C3.73337 6.75414 3.94533 6.66634 4.16634 6.66634H15.833C16.054 6.66634 16.266 6.75414 16.4223 6.91042C16.5785 7.0667 16.6663 7.27866 16.6663 7.49967V12.4997C16.6663 12.7207 16.5785 12.9326 16.4223 13.0889C16.266 13.2452 16.054 13.333 15.833 13.333H4.16634C3.94533 13.333 3.73337 13.2452 3.57709 13.0889C3.42081 12.9326 3.33301 12.7207 3.33301 12.4997V7.49967Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/section.81ee435525e66f39c56a0df93e9a40af.svg";
export { ForwardRef as ReactComponent };